export default __webpack_public_path__ + "static/media/DNo.15-1.2b6e8c71.jpg";